// 需要添加tab的模块
export const IDROUTES_MAP = [
  { title: "新增核查", path: "/inspect_review/proof/add" },
  { title: "批量录入", path: "/reward/entry" },
  { title: "批量修改", path: "/compensate/edit" },
  { title: "批量细化", path: "/manage_list/edit" },
  { title: "系统设置-活动-详情", path: "/system/activities/:type" },
  { title: "系统设置-活动-绑定情况", path: "/system/activities-bind" },
  {
    title: "包装涂画上报-详情",
    path: "/inspect_review/package_picture_report/detail",
  },
  {
    title: "违规上报-详情",
    path: "/inspect_review/violation_toss_report/detail",
  },
  {
    title: "恶意破坏上报-详情",
    path: "/inspect_review/malice_destroy_report/detail",
  },
  { title: "中转码货上报-详情", path: "/inspect_review/transfer_goods/detail" },
  { title: "车门上锁上报-详情", path: "/inspect_review/car_door_lock/detail" },
  { title: "流程标准提议-新增", path: "/process_standard/add" },
  { title: "核查举证", path: "/inspect_review/proof/" },
  { title: "核查无结果/无责举报", path: "/inspect_review/inconclusive/" },
  { title: "重点品类评审", path: "/inspect_review/review/detail_emphasis/" },
  { title: "包装评审", path: "/inspect_review/review/detail_pkg/" },
  { title: "包装评审（旧）", path: "/inspect_review/review/detail_pkg_old/" },
  { title: "承运环节评审", path: "/inspect_review/review/detail_carriage/" },
  { title: "全环节评审", path: "/inspect_review/review/detail_whole/" },
  {
    title: "明确异常环节评审",
    path: "/inspect_review/review/detail_abnormal/",
  },
  {
    title: "包装涂画核查评审",
    path: "/inspect_review/review/detail_pkg_picture/",
  },
  {
    title: "保价件核查评审",
    path: "/inspect_review/review/detail_high_figure/",
  },
  {
    title: "木质包装核查评审",
    path: "/inspect_review/review/detail_wooden_package/",
  },
  {
    title: "高价值全环节核查",
    path: "/inspect_review/review/detail_whole_high/",
  },
  {
    title: "大件产品全环节核查",
    path: "/inspect_review/review/detail_large_product/",
  },
  {
    title: "大件场地全环节评审",
    path: "/inspect_review/review/detail_whole_large/",
  },
  {
    title: "定向网点核查评审",
    path: "/inspect_review/review/detail_targeted_deptcode/",
  },
  {
    title: "防湿损包装核查",
    path: "/inspect_review/review/detail_moisture_proof/",
  },
  {
    title: "高价件派件验视核查",
    path: "/inspect_review/review/detail_high_price/",
  },
  { title: "核查评审", path: "/inspect_review/review/" },
  { title: "评审结果审核", path: "/inspect_review/check/" },
  { title: "评审结果公示", path: "/inspect_review/show/" },
  { title: "本部质量管理", path: "/manage_office/" },
  { title: "地区质量管理", path: "/manage_region/" },
  { title: "地区质量管理", path: "/manage_region_new/" },
  { title: "时效客诉定责", path: "/time_limit/" },
  { title: "客诉解决定责", path: "/resolve_complaints/" },
  { title: "经手损坏诊断记录", path: "/abnormalDiagnosis/" },
  { title: "奖惩管理", path: "/reward/" },
  { title: "综合查询", path: "/search/" },
  { title: "流程标准提议", path: "/process_standard/detail/" },
  { title: "活动介绍", path: "/red_packet/introduce" },
  { title: "我的红包", path: "/red_packet" },
  { title: "质量管理过程透视", path: "/chart" },
  { title: "个人中心", path: "/center" },
  { title: "sql查询", path: "/sql" },
  { title: "sql导入", path: "/sqlImport" },
  { title: "计算页面", path: "/compute" },
  { title: "接口人预警配置", path: "/system/contact_config" },
  { title: "快件安全预警详情", path: "/system/special_product_assistant/detail" },
  { title: "月结预警配置", path: "/system/damage_record" },
];

export const EXAMIN_MAP: Record<string, string> = {
  "2": "问题件核查",
  "3": "规则核查",
  "11": "明确异常环节核查",
  "10": "承运环节上报核查",
  "12": "包装涂画核查",
  "13": "中转码货核查",
  "6": "中转包装核查",
  "7": "外包装图片核查",
  "1": "重点品类包装核查",
  "4": "到件包装核查",
  "5": "月结客户包装核查",
  "8": "包装核查",
  "9": "全环节核查",
  "14": "保价件核查",
  "15": "木质包装核查",
  "16": "车门上锁核查",
  "17": "高价值全环节核查",
  "18": "大件场地全环节核查",
  "19": "定向网点核查",
  "20": "防湿损包装核查",
  "21": "高价件派件验视核查",
  "22": "大件产品全环节核查",
  "23": "超越计划客户核查",
  "24": "核查无结果/无责",
};

export const en: Record<string, string> = {
  质量管理平台: "Quality Management Platform",
  欢迎使用质量管理平台: "Welcome to the Quality Management Platform",

  // 角色
  管理员: "administrator",
  百源管理角色: "basp administrator",
  系统管理员: "system administrator",
  本部质量人员: "HQ quality role",
  地区质量人员: "OSR quality role",
  本部评审人: "HQ assessor",
  损坏接口人: "damaged interface staff",
  工单处理员: "order processor",
  冷运评审人: "cold assessor",
  快运评审人: "fast assessor",
  速运评审人: "express assessor",
  快运本部人员: "fast HQ staff",
  冷运本部人员: "cold HQ staff",
  速运本部人员: "express HQ staff",
  巴枪操作人员: "HQ staff",
  速运图片评审人: "express picture assessor",
  快运图片评审人: "fast picture assessor",
  冷运图片评审人: "cold picture assessor",
  高经运营: "higher level operator",

  // ===================== 左侧菜单 ========================
  首页: "Front Page",
  质量任务中心: "Quality Task Center",
  质量管理过程透视: "Quality Management Process Analysis",
  任务中心: "Task center",
  报表任务中心: "Report Task center",
  历史图片查询: "Inquiry of historical photo",
  综合查询: "Comprehensive inquiry",
  问题件上报: "Report",
  本部质量管理: "HQ quality management",
  地区质量管理: "OSR quality management",
  "地区质量管理（新）": "OSR quality management(new)",
  免责报备: "Liability exemption filing",
  列表: "List",
  审批: "Approval",
  奖惩管理: "Awards and punishment management",
  业务赔偿: "Business compensation",
  人工核查: "Human verification",
  核查举证: "Inspect proof-providing",
  核查评审: "Inspect review",
  评审结果审核: "Review result audit",
  评审结果公示: "Review result publicity",
  核查统计: "Verification of statistical",
  待处理任务: "Waiting tasks",
  系统设置: "System settings",
  节假日配置: "Holiday configuration",
  参数配置: "Parameter configuration",
  托寄物类型配置: "Carrier type configuration",
  工作日历: "Working calendar",
  奖惩规则配置: "Reward and punishment configuration",
  流程时长配置: "Process Time configuration",
  界定规则: "Define rules",
  评审任务转让: "Review task assignment",
  意见反馈: "Opinion feedback",
  系统建议: "system suggest",
  我的红包: "my red packets",
  系统公告: "system notice",
  不再提示: "No tips",
  知道了: "Got it",
  暂无红包: "No red packets",
  评审标签: "judge tag",
  时效客诉定责: "Timeliness Customer Complaint Responsibility",
  定责标准查询: "Responsibility Standard Query",
  流程标准提议: "Process Standard Proposal",
  转问题件失败查询: "Failed Problem Case Conversion Query",
  经手损坏诊断记录: "Damage Diagnosis Record",
  总部评价查询: "Headquarters Evaluation Query",
};
